<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    class="text-current"
  >
    <path
      d="M14.8923 3.10728C11.6379 -0.146743 6.36141 -0.147106 3.10667 3.10728C-0.147716 6.36166 -0.147354 11.6382 3.10667 14.8929C6.36105 18.1466 11.6376 18.1469 14.8923 14.8929C18.1463 11.6382 18.146 6.36202 14.8923 3.10728ZM10.0861 12.6233C10.0861 13.2237 9.59949 13.7103 8.99912 13.7103C8.39875 13.7103 7.91216 13.2237 7.91216 12.6233V8.27545C7.91216 7.67508 8.39875 7.18848 8.99912 7.18848C9.59949 7.18848 10.0861 7.67508 10.0861 8.27545V12.6233ZM8.97992 6.41746C8.35383 6.41746 7.93643 5.97398 7.94947 5.42651C7.93643 4.85259 8.35383 4.42251 8.9926 4.42251C9.63174 4.42251 10.0361 4.85295 10.0495 5.42651C10.0491 5.97398 9.6321 6.41746 8.97992 6.41746Z"
      fill="currentColor"
    />
  </svg>
</template>
